/**
 * The player web portal's own namespace, `player` (spec/15 §2).
 *
 * A separate entry point rather than a member of `namespaces`: the console, the kiosk and the store
 * apps never load it. `apps/player-web` passes it to `createI18n` as extra resources:
 *
 *   createI18n({ language, extraResources: playerWebResources, use: [initReactI18next] });
 */
import playerWebEn from './locales/en/player-web.js';
export const playerWebNamespace = 'player';
export const playerWebResources = {
    en: { player: playerWebEn },
};
//# sourceMappingURL=player-web.js.map